<template>
  <div class="monit-page">
    <div class="monit-main row justify-content-sb">
      <h3 v-if="mobile" class="page-title col-xs-12 col-sm-6 pt-2">
        Monitore atuadores
      </h3>
      <toolbar v-if="mobile" class="col-xs-12 col-sm-6" :is-mobile="mobile" :filter-opt="filterOpt"
        :filter-tag="filterBy === 100 ? true : false" :filters="filters" :is-filtering="isFiltering"
        @filter-by="onFilterBy" @search="searchBy" @clear-search="onClearSearch" @reset="resetProp"
        @type-change="changeTypeMobile" :type-filtering="
          tab1.toLowerCase() === 'exibir todos' ? '' : tab1.toLowerCase()
        " :is-searching="isSearching" :not-exists="showErrorNotFound" :not-search="showErrorNotSearch" />
      <div v-if="loading" class="col-xs-12 center-xs mt-2">
        <spinner /> Aguarde...
      </div>

      <div v-if="showErrorNotFound" class="
          EmptyRequest
          w-100
          p-0
          row
          center-xs center-md center-sm center-xs
          mt-3
        ">
        <img :src="emptyIcon" class="empty" />
        <span>Não há atuadores para exibir. Para cadastrar um novo,
          <router-link to="/registers/equips">clique aqui</router-link>.
        </span>
      </div>

      <div v-if="showErrorNotSearch && !showErrorNotFound" class="EmptyRequest row center-xs mx-2 md-12 w-100 p-0 mt-3"
        style="text-align: left">
        <img :src="searchIcon" class="empty" />
        <span>
          Não foi possível realizar a busca,
          <b-link @click="resetSearch"> clique aqui </b-link> para voltar a
          exibir os atuadores.
        </span>
      </div>

      <div class="container-cards">
        <div v-for="(item, index) in orderedList" :key="index" class="space-card">
          <router-link :to="`/monitoring/actuators/${type ? type : ''}`" @click.native="
            () => {
              openDetailsDialog(item);
              selectedCard = index;
            }
          ">
            <div :class="`monitCard ${BGRF(item.RF_STAT, item.UPDATE)}  ${
              selectedCard == index ? 'activeCard' : ''
            }`">
              <div :class="`top ${setBG(item)}`"></div>
              <div class="monit-name">
                {{ item.NAME }}
              </div>
              <span v-if="item.ID > 1000000 && item.OPEN && item.RF_STAT !== 8" class="arrow"
                style="vertical-align: -3px">
                <arrow-up-icon v-if="item.FLOW > item.MAX_FLOW" title="" />
                <arrow-down-icon v-else-if="item.FLOW < item.MIN_FLOW" title="" />
              </span>

              <span v-else-if="item.ID < 1000000 && item.RF_STAT !== 8" class="pump-icon">
                <pump-on-icon v-if="item.OPEN" title="" style="vertical-align: -3px" />
                <pump-off-icon v-else-if="!item.OPEN" fillColor="" customWidth="20" title=""
                  style="vertical-align: 2px" />
              </span>

              <span v-if="item.HYDRO && item.RF_STAT !== 8" class="info">
                {{ `${item.FLOW}${unitFlow(item.UNIT_FLOW)}` }}
                <br />
              </span>

              <div v-if="
                item.ID > 1000000 &&
                item.OPEN &&
                item.MAX_FLOW &&
                item.FLOW > item.MAX_FLOW &&
                item.RF_STAT !== 8
              ">
                Máxima: {{ item.MAX_FLOW }}{{unitFlow(item.UNIT_FLOW)}}
              </div>
              <div v-else-if="
                item.ID > 1000000 &&
                item.OPEN &&
                item.MIN_FLOW &&
                item.FLOW < item.MIN_FLOW &&
                item.RF_STAT !== 8
              ">
                Mínima: {{ item.MIN_FLOW }}{{unitFlow(item.UNIT_FLOW)}}
              </div>
              <div class="monit-detail" v-if="item.MANUAL && item.RF_STAT !== 8">
                MANUAL
              </div>
              <div class="monit-detail" v-if="item.ID < 1000000 && item.RF_STAT !== 8">
                BOMBA
              </div>
              <div v-show="formatStatusDir(item)" class="warn-card">
                <alert-icon title="" style="font-size: 0.9em" /><span>{{
                formatStatusDir(item)
                }}</span>
              </div>
              <footer>
                <div id="date">{{ formatUpdate(item.UPDATE) }}</div>
                <div :class="`status ${setBG(item)}`">
                  {{ selectInfoStatus(item) }}
                </div>
              </footer>
            </div>
          </router-link>
        </div>
      </div>
    </div>
    <!-- BARRA DIREITA -->
    <div class="monit-helper" v-if="!mobile">
      <div class="container-helper">
        <header>
          <div class="header-group">
            <water-icon title="" customHeight="20px" />
            <div class="title-monit-helper">Monitore Atuadores</div>
          </div>

          <toolbar v-if="!mobile" :is-mobile="mobile" :filter-opt="filterOpt" :is-filtering="isFiltering"
            @filter-by="onFilterBy" @search="searchBy" @clear-search="onClearSearch" :type-filtering="
              tab1.toLowerCase() === 'exibir todos' ? '' : tab1.toLowerCase()
            " :is-searching="isSearching" :not-exists="showErrorNotFound" :not-search="showErrorNotSearch" />
        </header>
        <div class="filter-container mt-2">
          <div class="col-xs-12 filter-title">
            <h5>Atuadores</h5>
            <span>{{ orderedList.length }}</span>
          </div>

          <div class="label ml-2 mr-2 mt-3" v-if="!mobile && actuatorsModels.length">
            Filtrar por modelo:
          </div>
          <div class="filter-model col-xs-12 ml-2 mr-2 mt-0 mb-0">
            <b-form-group v-if="!mobile" class="mb-0">
              <b-form-checkbox-group id="checkbox-group-1" v-model="selectedCheckbox" :options="actuatorsModels"
                name="filters" button-variant="info" size="sm"></b-form-checkbox-group>
            </b-form-group>
          </div>

          <div class="label ml-2 mr-2 mb-2 mt-3" v-if="!mobile">
            Filtrar por status:
          </div>
          <b-form-radio-group label="Filtro por comunicação: " v-model="selectedRadiusButton" buttons
            button-variant="light" size="md">
            <div class="col-12">
              <b-form-radio name="Exibir todos" :value="null">
                Exibir todos</b-form-radio>
              <b-form-radio name="Abertos" :value="1">
                <!-- Abertos -->
                Abertos ({{ alerts[1].length }})
              </b-form-radio>
              <b-form-radio name="Fechados" :value="0">
                <!-- Fechados -->
                Fechados ({{ alerts[0].length }})
              </b-form-radio>
              <b-form-radio name="Em manual" :value="11">
                <!-- Em manual -->
                Em manual ({{ alerts[11].length }})
              </b-form-radio>
              <b-form-radio name="Ativas" :value="'rf'">
                <!-- Problemas de comunicação -->
                Problemas de comunicação ({{ alerts["rf"].length }})
              </b-form-radio>
            </div>
          </b-form-radio-group>
        </div>
      </div>
    </div>
    <actuator-details :item="selected" :status-color="variant" :updated="updated" :variant="variant" :is-mobile="mobile"
      :show-details="showDetails" @close-details="closeDetails" />
  </div>
</template>

<script>
import { updateFormatter } from "@/pages/components/helpers";
import { monit } from "@/api";
import EventBus from "@/pages/components/eventBus";
export default {
  name: "monit-actuators",
  props: {
    mobile: Boolean,
  },
  data() {
    return {
      showDetails: false,
      backendNow: null,
      selectedCard: null,
      loading: true,
      selected: {},
      filterBy: 100,
      tab1: "",
      tab2: "",
      fullList: [],
      list: [],
      emptyIcon: require("../../../assets/icons/Empty.svg"),
      searchIcon: require("../../../assets/icons/search.svg"),
      type: null,
      missingResults: false,
      isSearching: false,
      isFiltering: false,
      filter: "",
      filterOpt: "",
      actuatorsModels: [],
      filters: [
        { value: 1, text: "Abertos" },
        { value: 0, text: "Fechados" },
        { value: 11, text: "Em manual" },
        { value: "rf", text: "Problemas de comunicação" },
      ],
      items: [],
      controller: null,
      timeout: null,
      alerts: {
        1: [],
        0: [],
        1000000: [],
        11: [],
        rf: [],
      },
      showErrorNotFound: false,
      showErrorNotSearch: false,
      selectedCheckbox: [],
      selectedRadiusButton: "",
    };
  },
  created() {
    this.$emit(
      "title-change",
      this.mobile ? "M. de Atuadores" : "Monitoramento de Atuadores"
    );
    this.controller = new AbortController();
    this.selectedRadiusButton = null;
    this.monitLoop();
    if (!this.type) {
      this.tab1 = "EXIBIR TODOS";
    }
  },
  beforeDestroy() {
    this.controller.abort();
    clearTimeout(this.timeout);
  },
  watch: {
    selectedCheckbox(newValue) {
      if (!this.mobile) {
        this.isActive(this.items);
      }
    },
    selectedRadiusButton(v) {
      if (v != null) {
        this.onFilterBy(v);
      } else {
        this.showErrorNotSearch = false;
        this.onFilterBy(100);
      }
    },
    mobile(newValue, oldValue) {
      if (newValue) {
        this.showErrorNotSearch = false;
        this.showErrorNotFound = false;
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.isSearching = false;
        this.filter = "";
      } else {
        this.resetSearch();
      }
    },
  },
  methods: {
    unitFlow(item_unit_flow) {
      return item_unit_flow ? item_unit_flow : 'm³/h'
    },
    selectCard(item, index) {
      this.selectedCard = index;
      openDetailsDialog(item);
    },
    closeDetails() {
      this.showDetails = false;
      this.selectedCard = null;
      this.selected = {};
    },
    resetSearch() {
      this.selectedCheckbox = [];
      this.selectedRadiusButton = null;
      EventBus.cleanInputSearch();
      this.filter = "";
      // this.resetDropdown();
      this.isSearching = false;
      this.items = this.fullList;
      this.showErrorNotSearch = false;
      this.resetProp();
      this.resetDropdown();
      this.clearSearchInput();
    },
    onClearSearch() {
      this.filter = "";
      this.resetDropdown();
    },
    // selectDropdownItem(option) {
    //   this.type = option;
    //   this.clearSearchInput();
    // },
    changeTypeMobile(t) {
      this.type = t;
    },
    resetProp() {
      this.onFilterBy(100);
    },
    resetDropdown() {
      this.type = null;
      this.tab1 = "EXIBIR TODOS";
      this.title = "ALL";
      this.isSearching = false;
      // this.filter=""
      this.showErrorNotSearch = false;
      this.items = this.fullList;
    },
    clearSearchInput() {
      if (!!this.$children[0] && this.$children[0].length > 0) {
        this.$children[0].clearText();
      }
      this.isSearching = false;
      this.items = this.fullList;
    },
    isSearchBombs(result) {
      let filter;
      filter = result.filter((item) => item.ID < 1000000);
      if (filter.length) {
        this.showErrorNotSearch = false;
        return filter;
      } else {
        this.showErrorNotSearch = true;
        return [];
      }
    },
    isSearchActuators(result) {
      let filter;
      filter = result.filter((item) => item.ID > 1000000);
      if (filter.length) {
        this.showErrorNotSearch = false;
        return filter;
      } else {
        this.showErrorNotSearch = true;
        return [];
      }
    },
    isSearchCheckbox(result) {
      if (this.mobile) {
        let filter;
        filter = result.filter((item) => item.ID > 1000000);
        if (filter.length) {
          this.showErrorNotSearch = false;
          return filter;
        } else {
          this.showErrorNotSearch = true;
          return [];
        }
      } else {
        let results = [];
        for (let checkbox of this.selectedCheckbox) {
          let filter = result.filter((item) => item.MODEL === checkbox);
          results.push(...filter);
        }
        if (results.length) {
          this.showErrorNotSearch = false;
          return results.sort((a, b) => a.ID - b.ID);
        } else {
          this.showErrorNotSearch = true;
          return [];
        }
      }
    },
    isSearch(result) {
      let filter;
      filter = result.filter((item) => {
        if (item.MODEL && item.MODEL.indexOf(this.filter) > -1) {
          return true;
        } else if (item.DIR && item.DIR.indexOf(this.filter) > -1) {
          return true;
        } else if (item.ID && item.ID.indexOf(this.filter) > -1) {
          return true;
        } else {
          return item.NAME.indexOf(this.filter) > -1;
        }
      });
      if (filter.length) {
        this.showErrorNotSearch = false;
        return filter;
      } else {
        this.showErrorNotSearch = true;
        return [];
      }
    },
    isActive(result) {
      let actuators = [];
      if (
        !this.mobile &&
        !!this.selectedCheckbox &&
        this.selectedCheckbox.length > 0
      ) {
        this.isFiltering = false;
        actuators = this.isSearchCheckbox(result);
        if (result.length) {
        }
      } else if (
        !this.mobile &&
        !!this.selectedCheckbox &&
        !this.selectedCheckbox.length
      ) {
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        actuators = this.fullList;
      } else if (!this.mobile) {
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        this.isFiltering = false;
        actuators = this.fullList;
      }
      if (this.mobile && this.type === "bombas") {
        this.selectedRadiusButton = null;
        this.tab1 = `BOMBAS`;
        // this.clearSearch();
        this.title = "";
        if (result.length) {
          actuators = this.isSearchBombs(result);
        }
      } else if (this.mobile && this.type === "atuadores") {
        this.selectedRadiusButton = null;
        this.tab1 = "ATUADORES";
        this.title = "";
        // this.clearSearch();
        if (result.length) {
          actuators = this.isSearchActuators(result);
        }
      } else if (this.mobile && !this.type) {
        this.selectedRadiusButton = null;
        this.selectedCheckbox = [];
        this.tab1 = "EXIBIR TODOS";
        this.title = "ALL";
        actuators = this.fullList;
      }
      return actuators;
    },
    monitLoop() {
      monit
        .actuator(this.controller)
        .then((res) => {
          this.backendNow = Date.parse(res.headers.get("date"));
          return res.json();
        })
        .then((ret) => {
          this.loadFilterModel(ret);
          let list = ret;
          this.fullList = list;
          if (this.isSearching && this.validFilter && list.length) {
            this.items = this.isSearch(list);
          } else {
            this.items = list;
          }
          if (this.loading) this.loading = false;
          if (Object.keys(this.selected).length && this.selected.ID) {
            this.selected =
              this.items.filter((e) => e.ID == this.selected.ID)[0] ||
              this.selected;
          }
        })
        .then((_) => {
          if (!this.loading && !this.items.length && !this.showErrorNotSearch) {
            this.showErrorNotFound = true;
          } else {
            this.showErrorNotFound = false;
          }
        })
        .then((ret) => {
          if (ret !== "AbortError") {
            this.timeout = setTimeout(this.monitLoop, 2000);
          }
        })
        .catch((err) => {
          console.error(err);
          return err.name;
        });
    },
    formatUpdate(update) {
      return updateFormatter(update);
    },
    setBG(item) {
      if (item == "rf") return "bg-rf";
      else if (item == 1000000) return "bg-pacific-blue";
      else if (item == 11) return "bg-orange";
      else if (item == 1) return "bg-3v3";
      else if (!item) return "bg-black";
      let isValve = item.ID > 1000000;
      if (item == 0 || !item.OPEN) return "bg-black-body";
      else if (item.OPEN == 2) return "bg-grey";
      else if (item == 11) return "bg-orange";
      else if (isValve && item.FLOW < item.MIN_FLOW) return "bg-red-body";
      else if (isValve && item.FLOW > item.MAX_FLOW) return "bg-yellow";
      else if (!isValve && item.HYDRO && !item.FLOW) return "bg-red-body";
      return "bg-3v3";
    },
    selectInfoStatus(item) {
      if (item == "rf") return "bg-rf";
      else if (item == 1000000) return "bg-pacific-blue";
      else if (item == 11) return "bg-orange";
      else if (item == 1) return "ATIVADO";
      else if (!item) return "bg-black";
      let isValve = item.ID > 1000000;
      if (item == 0 || !item.OPEN) return "DESATIVADO";
      else if (item.OPEN == 2) return "INDEFINIDO";
      else if (item == 11) return "bg-orange";
      else if (isValve && item.FLOW < item.MIN_FLOW) return "ABAIXO";
      else if (isValve && item.FLOW > item.MAX_FLOW) return "ACIMA";
      else if (!isValve && item.HYDRO && !item.FLOW) return "ABAIXO";
      return "ABERTO";
    },
    BGRF(stat, update) {
      switch (stat) {
        case 0:
          return "bg3v3";
        // case 7:
        //   return "bg-yellow";
        case 8:
          return "bg-red-body";
        case 9:
          return "bg-black-body";
        default:
          return "";
      }
    },
    formatStatusDir(item) {
      switch (item.RF_STAT) {
        case 8:
          return ` O DIR ${item.DIR} está sem comunicar.`;
        case 9:
          return ` O DIR ${item.DIR} está sem comunicar.`;
        default:
          return null;
      }
    },
    searchBy(name) {
      this.isSearching = !!name.split(" ").join("");
      this.filter = name.toUpperCase();
    },
    loadFilterModel(actuators) {
      this.loading = true;

      const models = Array.from(new Set([...actuators.map((actuator) => actuator.MODEL)]))

      models.sort((a, b) => {
        if (a < b) {
          return -1;
        } else if (a > b) {
          return 1;
        }
        return 0;
      })

      const sanitalizedOptions = models.map((model) => {
        return {
          text: model,
          value: model
        }
      });

      this.actuatorsModels = sanitalizedOptions
      this.loading = false;
    },
    clearSearch() {
      this.showErrorNotSearch = false;
    },
    onFilterBy(value) {
      this.isFiltering = value != 100;
      if (value.text) {
        this.filterOpt = value.text;
      }
      this.filterBy = value;
    },
    openDetailsDialog(item) {
      this.selected = item;
      this.showDetails = true;
    },
  },
  computed: {
    updated() {
      return Object.keys(this.selected).length && this.selected.UPDATE
        ? this.formatUpdate(this.selected.UPDATE)
        : "";
    },
    variant() {
      return this.setBG(this.selected).split("-")[1];
    },
    validSearch() {
      return !!this.filter.split(" ").join("");
    },
    orderedList() {
      let filter = this.filterBy;
      let result = this.items;
      if (result.length && this.type && this.type == "atuadores") {
        result = this.isActive(result);
      } else if (
        result.length &&
        this.type &&
        this.type == "bombas" &&
        !this.selected.ID
      ) {
        result = this.isActive(result);
      }

      if (result.length > 0) {
        result = this.isActive(result);
      }

      this.alerts[1] = result.filter((e) => !!e.OPEN);
      this.alerts[0] = result.filter((e) => !e.OPEN);
      this.alerts[1000000] = result.filter((e) => e.ID < 1000000);
      this.alerts[11] = result.filter((e) => !!e.MANUAL);
      this.alerts["rf"] = result.filter((e) => this.BGRF(e.RF_STAT) != "bg3v3");

      if (
        this.isSearching &&
        this.validSearch &&
        result.length &&
        this.selectedRadiusButton == null
      ) {
        result = this.isSearch(result);
        this.alerts[1] = result.filter((e) => !!e.OPEN);
        this.alerts[0] = result.filter((e) => !e.OPEN);
        this.alerts[1000000] = result.filter((e) => e.ID < 1000000);
        this.alerts[11] = result.filter((e) => !!e.MANUAL);
        this.alerts["rf"] = result.filter(
          (e) => this.BGRF(e.RF_STAT) != "bg3v3"
        );
      }
      if (
        this.isSearching &&
        this.validSearch &&
        this.selectedRadiusButton !== null
      ) {
        result = this.isSearch(result);
        this.alerts[1] = result.filter((e) => !!e.OPEN);
        this.alerts[0] = result.filter((e) => !e.OPEN);
        this.alerts[1000000] = result.filter((e) => e.ID < 1000000);
        this.alerts[11] = result.filter((e) => !!e.MANUAL);
        this.alerts["rf"] = result.filter(
          (e) => this.BGRF(e.RF_STAT) != "bg3v3"
        );
        if (filter != 100) {
          if (this.mobile) {
            result = this.alerts[filter.value];
            try {
              if (!result.length) {
                this.showErrorNotSearch = true;
              } else {
                this.showErrorNotSearch = false;
              }
            } catch (error) {
              console.log("Result -> error :", error);
            }
          } else {
            result = this.isSearch(this.alerts[filter]);
            if (!result.length) {
              this.showErrorNotSearch = true;
            } else {
              this.showErrorNotSearch = false;
            }
          }
        }
      } else if (filter != 100) {
        if (this.mobile) {
          result = this.alerts[filter.value];
          try {
            if (!result.length) {
              this.showErrorNotSearch = true;
            } else {
              this.showErrorNotSearch = false;
            }
          } catch (error) {
            console.log("Result -> error :", error);
          }
        } else {
          result = this.isSearch(this.alerts[filter]);
          if (!result.length) {
            this.showErrorNotSearch = true;
          } else {
            this.showErrorNotSearch = false;
          }
        }
      }
      return result;
    },
  },
};
</script>
